@file:OptIn(InternalResourceApi::class)

package animations.core.model.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/animations.core.model.generated.resources/"

@delegate:ResourceContentHash(2_124_744_128)
internal val Res.drawable.code: DrawableResource by lazy {
      DrawableResource("drawable:code", setOf(
        ResourceItem(setOf(), "${MD}drawable/code.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-930_455_583)
internal val Res.drawable.faders: DrawableResource by lazy {
      DrawableResource("drawable:faders", setOf(
        ResourceItem(setOf(), "${MD}drawable/faders.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(987_926_321)
internal val Res.drawable.link: DrawableResource by lazy {
      DrawableResource("drawable:link", setOf(
        ResourceItem(setOf(), "${MD}drawable/link.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("code", Res.drawable.code)
  map.put("faders", Res.drawable.faders)
  map.put("link", Res.drawable.link)
}
